import React, { Component } from 'react'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import AccountListPageUI from './AccountListPageUI'

class AccountListPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      deleteSubmitted: false,
      loginSubmitted: false,
      accountList: null,
      filteredAccountList: null,
      selectedAccountId: null,
      searchFilter: '',
      copyToClipboardText: null,
      createAccountMode: false,
      tdsStatusUpdateMode: false,
      selectedTdsAccount: null
    }
  }

  render() {
    return (
      <AccountListPageUI
        context={this.props.context}
        onRowClick={this.onRowClick}
        errorList={this.state.errorList}
        accountList={this.state.accountList}
        filteredAccountList={this.state.filteredAccountList}
        selectedAccountId={this.state.selectedAccountId}
        onRefreshClick={this.onRefreshClick}
        onDeleteClick={this.onDeleteClick}
        deleteSubmitted={this.state.deleteSubmitted}
        onLoginClick={this.onLoginClick}
        loginSubmitted={this.state.loginSubmitted}
        onOpenTdsStatusUpdateModal={this.onOpenTdsStatusUpdateModal}
        onCancelTdsStatusUpdateModal={this.onCancelTdsStatusUpdateModal}
        onTdsStatusUpdated={this.onTdsStatusUpdated}
        tdsStatusUpdateMode={this.state.tdsStatusUpdateMode}
        selectedTdsAccount={this.state.selectedTdsAccount}
        copyToClipboardText={this.state.copyToClipboardText}
        onCopyToClipboard={this.onCopyToClipboard}
        searchFilter={this.state.searchFilter}
        onSearchFilterChange={this.onSearchFilterChange}
        onCreateAccountClick={() => { this.setState({ createAccountMode: true }) }}
        createAccountMode={this.state.createAccountMode}
        onCancelCreateAccount={() => { this.setState({ createAccountMode: false }) }}
        onTypeChange={this.onTypeChange}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getAllAccounts(context, context.filter)
  }

  onTypeChange = (type) => {
    let context = this.props.context
    this.getAllAccounts(context, type)
  }

  getAllAccounts(context, stp) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts`,
      cacheKey: CacheKeys.Accounts(context.session.userId, stp),
      callback: this.getAllAccountsCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context, {}, { stp: stp === 'stp' ? true : false })
  }

  getAllAccountsCallback = (response) => {
    let filtersStr = sessionStorage.getItem(CacheKeys.AccountsFilter())
    let filters = filtersStr ? JSON.parse(filtersStr) : {}

    this.applyFilters(response.accountList, filters.searchFilter ? filters.searchFilter : '', response.errorList)
  }

  onRowClick = (event) => {
    let accountId = event.currentTarget.getAttribute('data-row-id')
    window.location.href = `/su/accounts/${accountId}/kyc`
  }

  onLoginClick = (event) => {
    event.stopPropagation()
    let loginSubmitted = this.state.loginSubmitted
    if (loginSubmitted)
      return

    let accountId = event.target.getAttribute('data-row-id')

    this.setState({
      successMsg: null,
      errorList: [],
      loginSubmitted: true,
      selectedAccountId: accountId
    })

    RestApiUtils.put(this.props.context,
      `/api/su/accounts/${accountId}/impersonate`,
      this.onLoginCallback, {
    }
    )
  }

  onLoginCallback = (response) => {
    let errorList = []
    // this.setState({loginSubmitted: false})

    if (response.errorList.length) {
      response.errorList.forEach(error => {
        errorList.push(error.message)
      })
    }

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      loginSubmitted: false
    })

    if (errorList.length === 0) {
      this.props.context.onLogin(response.session)
    }
  }

  onDeleteClick = (event) => {
    event.stopPropagation()
    let deleteSubmitted = this.state.deleteSubmitted
    if (deleteSubmitted)
      return

    let accountId = event.target.getAttribute('data-row-id')

    this.setState({
      successMsg: null,
      errorList: [],
      deleteSubmitted: true,
      selectedAccountId: accountId
    })

    RestApiUtils.delete(this.props.context,
      `/api/su/accounts/${accountId}`, this.onDeleteCallback, {}
    )
  }

  onDeleteCallback = (response) => {
    let errorList = []

    if (response.errorList.length) {
      response.errorList.forEach(error => {
        errorList.push(error.message)
      })
    }

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      deleteSubmitted: false
    })

    if (errorList.length === 0) {
      this.onRefreshClick('noBusy')
    }
  }

  onOpenTdsStatusUpdateModal = (event) => {
    event.preventDefault()
    event.stopPropagation()
    const accountId = event.currentTarget.getAttribute('data-row-id')
    const selectedTdsAccount = (this.state.accountList || []).find(acc => acc.accountId === accountId) || null
    if (!selectedTdsAccount) {
      return
    }
    this.setState({
      selectedAccountId: accountId,
      selectedTdsAccount: selectedTdsAccount,
      tdsStatusUpdateMode: true
    })
  }

  onCancelTdsStatusUpdateModal = () => {
    this.setState({
      tdsStatusUpdateMode: false,
      selectedTdsAccount: null
    })
  }

  onTdsStatusUpdated = (accountId, tdsStatus) => {
    this.onRefreshClick('noBusy')
  }

  onCopyToClipboard = (text, result) => {
    this.setState({ copyToClipboardText: text })
    setTimeout(() => {
      this.setState({ copyToClipboardText: null })
    }, 3000)
  }

  onSearchFilterChange = (event) => {
    let searchFilter = event.target.value
    this.setState({ searchFilter: searchFilter })
    this.applyFilters(this.state.accountList, searchFilter)
  }

  applyFilters(accountList, searchFilter, errorList) {
    let filteredList = accountList
    if (searchFilter) {
      searchFilter = searchFilter.toLocaleLowerCase()
      filteredList = filteredList.filter(acc =>
        acc.accountName.toLocaleLowerCase().includes(searchFilter) ||
        (acc.businessName && acc.businessName.toLocaleLowerCase().includes(searchFilter)) ||
        acc.assignedUserName && acc.assignedUserName.toLocaleLowerCase().includes(searchFilter)
      )
    }

    this.setState({
      accountList: accountList,
      filteredAccountList: filteredList,
      searchFilter: searchFilter,
      errorList: errorList
    })

    let filters = { searchFilter: searchFilter }
    sessionStorage.setItem(CacheKeys.AccountsFilter(), JSON.stringify(filters))
  }

  onRefreshClick = (noBusy) => {
    CacheManager.removeObject(CacheKeys.Accounts(this.props.context.session.userId, this.props.context.filter))
    if (noBusy === 'noBusy')
      this.getAllAccounts(this.props.context, this.props.context.filter)
    else
      this.setState({ accountList: null, errorList: null },
        this.getAllAccounts(this.props.context, this.props.context.filter)
      )
  }
}

export default AccountListPageSF
